import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const ServiceViewModule = new Module({
  id: 'SERVICE:VIEW:*',
  name: 'Service',
  label: 'service',
  path: 'service',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Service/View'))
  ),
  actions: {
    addBulkRequest: {
      id: 'SERVICE:ADD:BULK-ADD',
      label: 'Bulk Add',
      name: 'add-bulk-request'
    },
    viewDetails: {
      id: 'SERVICE:VIEW:DETAILS',
      label: 'View Details',
      name: 'view-details'
    },
    // startPDIAgainstOrder: {
    //   id: 'ORDERS:VIEW:START-PDI-ORDER-t',
    //   name: 'start-pdi-against-order',
    //   label: 'Start PDI'
    // },
    // editFirmwareInOrder: {
    //   id: 'ORDERS:VIEW:EDIT-FIRMWARE-IN-ORDER-t',
    //   name: 'edit-firmware-in-order',
    //   label: 'Edit Firmware'
    // },
    // cancelOrder: {
    //   id: 'ORDERS:VIEW:CANCEL-ORDER-t',
    //   name: 'cancel-order',
    //   label: 'Cancel Order'
    // },
    opeMoadal: {
      id: 'SERVICES:VIEW:SERVICE-MODAL',
      name: 'service-modal',
      label: 'Details'
    },
    opeDispatchModal: {
      id: 'SERVICES:VIEW:DISPATCH-MODAL',
      name: 'dispatch-modal',
      label: 'Dispatch'
    }
  }
});

export const ServiceDetailsModule = new Module({
  id: 'SERVICE:VIEW:DETAILS',
  name: 'serviceDetails',
  path: 'service/details',
  pathDef: 'service/details/:orderId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Service/Form'))
  )
});


export const AddBulkRequestModule = new Module({
  id: 'SERVICE:ADD:BULK-ADD',
  name: 'add-bulk-request',
  path: 'service/add-bulk-request',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Service/BulkAdd'))
  ),
  actions: {
    // viewReport: {
    //   id: 'ORDERS:VIEW:REPORT-t',
    //   name: 'view-report',
    //   label: 'View Report'
    // },

    deleteAllocatedMaterial: {
      id: 'ORDERS:DELETE:ALLOCATED-MATERIAL-t',
      name: 'delete-allocated-material',
      label: 'Delete Allocated IMEI'
    },
  }
});

const ServiceModules = [
  ServiceViewModule,
  ServiceDetailsModule,
  AddBulkRequestModule
  // MaterialAllocationModule
];

export default new ModuleBundle('Service', ServiceModules);
